const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Prefix API-returned image paths with REACT_APP_API_URL.
 * Backend typically returns something like: "/image/<filename>" or "image/<filename>".
 */
export const getImageUrl = (path) => {
    if (!path) return "";
    if (typeof path !== "string") return String(path);

    const trimmed = path.trim();
    if (!trimmed) return "";

    // If it is already an absolute URL, keep it.
    if (/^https?:\/\//i.test(trimmed)) return trimmed;

    const base = (API_BASE_URL || "").replace(/\/$/, "");
    if (!base) return trimmed;

    // If it looks like an API path already:
    // - "/images/<name>" or "images/<name>"
    // - "/image/<name>" (legacy) -> convert to "/images/<name>"
    const hasAnySlash = trimmed.includes("/") || trimmed.includes("\\");
    if (hasAnySlash) {
        const normalized = trimmed.replace(/^\/+/, ""); // remove leading "/"

        if (/^images\//i.test(normalized)) {
            // encodeURI keeps slashes while encoding spaces etc.
            return `${base}/${encodeURI(normalized)}`;
        }

        // Legacy: /image/<name> -> /images/<name>
        if (/^image\//i.test(normalized)) {
            return `${base}/images/${encodeURIComponent(
                normalized.replace(/^image\//i, "")
            )}`;
        }

        // If it contains "/image/" anywhere, rewrite it to "/images/".
        if (normalized.toLowerCase().includes("/image/")) {
            const rewritten = normalized.replace(/\/image\//gi, "/images/");
            return `${base}/${encodeURI(rewritten)}`;
        }

        // Unknown relative path shape; just prefix base.
        return `${base}/${encodeURI(normalized)}`;
    }

    // Raw filename: "image_name.png" => `${base}/images/image_name.png`
    return `${base}/images/${encodeURIComponent(trimmed)}`;
};

